import _ from "lodash";
import store from "../store";

// format languages for before applying filters
export const getComputedLanguages = ({ languages, public_data }) => {
    if (!languages) languages = [];
    else if (languages.length === 0) {
        languages = undefined;
    } else if (languages.length === 1 && languages[0] === "selectAll") {
        languages = public_data ? store.getState().filterSettingReducer.masterLanguages : store.getState().filterSettingReducer.languagesActive;
        languages = languages.map((lang) => lang.id);
    }
    return languages;
};

// format countries for before applying filters
export const getComputedCountries = ({ countries, public_data }) => {
    if (!countries) countries = [];
    else if (countries.length === 0 || (countries.length === 1 && countries[0] === "selectAll")) {
        countries = public_data ? store.getState().filterSettingReducer.masterLocations : store.getState().filterSettingReducer.locationsActive;
        countries = countries.map((lang) => lang.id);
    }
    return countries;
};
// format logos for before applying filters
export const getComputedLogos = ({ logos, public_data }) => {
    if (!logos) logos = [];
    else if (logos.length === 0 || (logos.length === 1 && logos[0] === "selectAll")) {
        return [];
    }
    return logos;
};

// format platforms for before applying filters
export const getComputedPlatforms = ({ platforms, public_data }) => {
    if (!platforms) platforms = [];
    else if (platforms.length === 0 || (platforms.length === 1 && platforms[0] === "selectAll")) {
        platforms = public_data ? store.getState().filterSettingReducer.masterPlatforms : store.getState().filterSettingReducer.platformsActive;
        platforms = platforms.map((plt) => plt.id);
    }
    return platforms;
};

const getTopicDetails = (subtopicId, allTopics) => {
    return allTopics.find((tp) => tp.subtopic_id === subtopicId);
};

export const getComputedPublications = (publications) => {
    if (!publications) return publications;
    if (publications.length === 0) publications = undefined;
    else if (publications.length === 1 && publications[0] === "selectAll") {
        publications = "all_tagged_pubs";
    } else if (publications.length === 1 && publications[0] === "untaggedPubs") {
        publications = "all_untagged_pubs";
    } else if (publications.length === 1 && publications[0] === "otherTaggedPubs") {
        publications = "not_listed_pubs";
    }
    return publications;
};

export const formatTopicsSubtopics = (filter, subtopicsChecked = true, topicRequired = false) => {
    let allTopics = store.getState().filterSettingReducer.topicsAndSubtopics;
    let topicsObject = store.getState().filterSettingReducer.topicsObject;
    let topicsData = [];

    let selectedTopics = filter.filter_data.topics;
    let selectedSubtopics = filter.filter_data.subtopics;
    if (
        (selectedTopics.length === 0 && selectedSubtopics.length === 0 && topicRequired) ||
        (selectedTopics.length === 0 && subtopicsChecked === false && topicRequired) ||
        (selectedTopics.length === 1 && selectedTopics[0] === "ALL") ||
        (selectedSubtopics.length === 1 && selectedSubtopics[0] === "ALL")
    ) {
        //select all topics
        selectedTopics = Object.keys(topicsObject);
        subtopicsChecked = false;
    }

    if (subtopicsChecked) {
        filter.filter_data.subtopics.forEach((subtopic) => {
            let subtopicDetails = getTopicDetails(subtopic, allTopics);
            if (subtopicDetails) {
                let ind = topicsData.findIndex((d) => d.topic_id === subtopicDetails.topic_id);
                if (ind === -1) {
                    topicsData.push({
                        topic_id: subtopicDetails.topic_id,
                        name: subtopicDetails.topic_name,
                        subtopicIds: [subtopic],
                        subtopicNames: [
                            {
                                id: subtopic,
                                name: subtopicDetails.subtopic_name,
                            },
                        ],
                    });
                } else {
                    topicsData[ind].subtopicIds.push(subtopic);
                    topicsData[ind].subtopicNames.push({
                        id: subtopic,
                        name: subtopicDetails.subtopic_name,
                    });
                }
            }
        }, this);
    }

    selectedTopics.forEach((topic) => {
        let subtopics = allTopics;
        let subtopicsList = subtopics.filter((tpc) => tpc.topic_id === topic);
        if (subtopicsList.length > 0)
            topicsData.push({
                topic_id: topic,
                name: subtopicsList[0].topic_name,
                subtopicIds: subtopicsList.map((x) => x.subtopic_id),
                subtopicNames: subtopicsList.map((x) => {
                    return {
                        id: x.subtopic_id,
                        name: x.subtopic_name,
                    };
                }),
            });
    });

    return topicsData;
};
